import React from 'react';
import { SectionCard, SectionTitle } from '../Guide.styles';

interface GuideSectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
}

export const GuideSection: React.FC<GuideSectionProps> = ({ id, title, children }) => (
  <SectionCard id={id}>
    <SectionTitle variant="h5">{title}</SectionTitle>
    {children}
  </SectionCard>
);
